import React from 'react';

import PropTypes from 'prop-types';

import Actions from './components/Actions';
import {
  getMessage,
  getStatus,
  getLocalFormattedTime,
  getAssignee
} from './utils';

const Row = ({ order, fetchOrders, headers }) => {
  const {
    orderId,
    iotCompanyName,
    iotProductSelected,
    iotActivationOrRenwal,
    iotNewOrExisting,
    createdAt
  } = order;
  const { statusToolTip, statusId } = getStatus(order);
  const {
    orderAssignedTo,
    channelName,
    first_name: firstName,
    last_name: lastName
  } = order;

  return (
    <tr>
      <td data-header-label={headers[0]}>{orderId}</td>
      <td data-header-label={headers[1]}>{channelName}</td>
      <td data-header-label={headers[2]}>{`${firstName} ${lastName}`}</td>
      <td data-header-label={headers[3]}>{iotCompanyName}</td>
      <td data-header-label={headers[4]}>{iotProductSelected}</td>
      <td data-header-label={headers[5]}>{iotActivationOrRenwal}</td>
      <td data-header-label={headers[6]}>{iotNewOrExisting}</td>
      <td data-header-label={headers[7]}>{getLocalFormattedTime(createdAt)}</td>
      <td data-header-label={headers[8]}>{statusToolTip}</td>
      <td data-header-label={headers[9]}>{getAssignee(orderAssignedTo)}</td>
      <td data-header-label={headers[10]}>{getMessage(order, fetchOrders)}</td>
      <td data-header-label={headers[11]}>
        <div className="responsive-table__actions">
          <Actions status={statusId} order={order} fetchOrders={fetchOrders} />
        </div>
      </td>
    </tr>
  );
};

Row.propTypes = {
  order: PropTypes.objectOf(PropTypes.object).isRequired,
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default Row;
